// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"4a3256d8","455":"e6386b2d","977":"03632b34"}[chunkId] + ".chunk.js";
};